/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InApp/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import SecureIndicator from './SecureIndicator/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function InApp({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/Secure/InApp",
  isSubmitting
  
}) {
let messageComposeIsSecureValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'is_secure',
})
let messageComposeIsSecureIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let messageComposeIsSecureValueData1 = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'is_secure',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginRight={dtSpaceXxs}
 data="message_compose.is_secure"
 isSelected={messageComposeIsSecureValueData}
 onClick={onClick}
 disabled={messageComposeIsSecureIsSubmittingData}
 type="ghost"
 size="normal"
 title={messageComposeIsSecureValueData1 ? "Sent as secure message" : "Sent as insecure email"}
 data="message_compose.is_secure"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<SecureIndicator
{...childProps}
  viewPath={`${viewPath}/SecureIndicator`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}